module.exports = __webpack_public_path__ + "static/img/haila.9918bb7f.png";